import { z } from 'zod'

// Jitless mode disables zod's JIT-compiled parsers, whose `Function('')` eval
// probe triggers CSP violation reports. The flag is read at schema construction,
// so this MUST stay the first import in main.tsx.
z.config({ jitless: true })
